export default {
    parts: ['container', 'icon', 'errorIcon', 'text'],
    baseStyle: (props) => ({
        container: {
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            marginTop: 2
        },
        icon: {
            width: props?.isLarge ? 3 : 1,
            height: props?.isLarge ? 3 : 1,
            backgroundColor: 'webTypo.textSale'
        },
        errorIcon: {
            width: '13px',
            height: '13px'
        },
        text: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsRegular'
        }
    }),
    variants: {
        compact: {
            icon: {
                backgroundColor: 'webTheme.supportError'
            }
        }
    }
}
